// src/pages/Home.jsx
import { useNavigate } from "react-router-dom";
import API_URL from "./api/API"; // <-- Import SALON_NAME separately

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-3xl mx-auto flex flex-col items-center justify-center text-center">
        <h1 className="text-darkLighted font-light text-[32px] leading-snug mb-2">
          Welcome to <span className="text-black font-bold">DidYouSign</span>
        </h1>
        <p className="text-lg text-foreground mb-8">
          Register your business and start creating digital waivers in minutes.
        </p>

        <button
          onClick={() => navigate("/business/login")}
          className="inline-block bg-highlited rounded-full text-black font-medium py-4 px-10 hover:bg-[#D5AA00] transition"
        >
          Get Started
        </button>
      </div>

      <footer className="absolute bottom-4 text-xs text-foreground">
        © {new Date().getFullYear()} DidYouSign. All rights reserved.
      </footer>
    </div>
  );
}
